/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { IUser } from './user-menu.types';

/**
 * Component.
 */
@Component({ name: 'user-menu' })
export default class extends Vue {
  /**
   * Property `actions`.
   */
  @Prop({ default: () => [], type: Array })
  actions: {
    event: string;
    icon: string;
    label: string;
  }[];

  /**
   * Property `color`.
   */
  @Prop({ default: '--pk-color-grey-darken2' })
  color: string;

  /**
   * Property `size`.
   */
  @Prop({ default: '40' })
  size: string;

  /**
   * Property `user`.
   */
  @Prop({ default: null, type: Object })
  user: IUser;

  /**
   * Getter `email`.
   */
  get email() {
    const { email = null } = this.user || {};

    return email;
  }

  /**
   * Getter `initials`.
   */
  get initials() {
    const { initials = null } = this.user || {};

    return initials;
  }

  /**
   * Getter `name`.
   */
  get name() {
    const { name = null } = this.user || {};

    return name;
  }

  /**
   * Getter `photo`.
   */
  get photo() {
    const { photo = null } = this.user || {};

    return photo;
  }

  /**
   * Getter `menuActions`.
   */
  get menuActions() {
    const menuActions = [...this.actions];

    menuActions.push({
      event: 'logout',
      icon: 'mdi-logout',
      label: this.i18n('MAIN.ACTIONS.LOGOUT')
    });

    return menuActions;
  }

  /**
   * Handle emit action event.
   */
  handleEmitActionEvent(event: string) {
    if (event) {
      this.$emit(event);
    }
  }
}
